import { useToast } from './use-toast'
import * as Sentry from '@sentry/nextjs'
import { isAxiosError } from 'axios'
import { FormikErrors } from 'formik'
import { useTranslation } from 'next-i18next'
import { useCallback } from 'react'

export function useErrors() {
  const { toast } = useToast()
  const { t } = useTranslation()

  const handleError = useCallback(
    (error: any, setErrors?: (errors: FormikErrors<any>) => void) => {
      const toastError = (message: string) => {
        toast({
          title: message,
          variant: 'destructive',
        })
      }

      console.error(error)

      if (!isAxiosError(error)) {
        toastError(error.message)
        Sentry.captureException(error)
      }

      const { response } = error

      if (response.status === 422) {
        toastError(t('invalid_form_data'))
        console.error(response.data.errors)
      } else if (response?.status === 403) {
        toastError(t('permission_denied'))
      } else {
        toastError(error.message)
        Sentry.captureException(error)
      }

      setErrors?.(response.data.errors)
    },
    [t, toast]
  )

  return { handleError }
}
